import React from 'react';

import get from 'lodash/get';

import { SidePage, Section } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { useScreenGo } from '@gogame/screens';

import {
  MasterCampaignFormEdit,
  MasterCampaignFormDuplicate,
} from 'scenes/Influencers/MasterCampaigns/components/MasterCampaignForm';
import PromoCodeDetails from 'scenes/PromoCodes/components/PromoCodeDetails';

import { useLoadMasterCampaignDetails } from '../../data';
import ActionsWrapper from '../Actions';
import Agencies from './Agencies';
import BudgetAndPayoutSection from './BudgetAndPayoutSection';
import GeneralSection from './GeneralSection';
import Metadata from './Metadata';

const MasterCampaignDetails = ({ id, onClose, onChange, onExited, open }) => {
  const go = useScreenGo();
  const { data, isLoading, isRefetching } = useLoadMasterCampaignDetails(id);
  const [childComponent, openChildComponent] = useChildComponent();

  const handleDuplicate = () => {
    openChildComponent(MasterCampaignFormDuplicate, {
      id: data.id,
      onSubmit: ({ id }) => {
        go(id);
        onChange();
      },
    });
  };

  const handleEdit = () => {
    openChildComponent(MasterCampaignFormEdit, {
      id: data.id,
      onSubmit: async () => {
        onChange();
      },
    });
  };

  const handleOpenPromoCode = (_e, { id: promoCode }) => {
    openChildComponent(PromoCodeDetails, {
      id: promoCode,
      onChange: async () => {
        onChange();
      },
    });
  };
  const agencyCount = data?.agencies.length ? `(${data?.agencies.length})` : '';

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={'Master Campaign'}
        subTitle={get(data, 'name')}
        entityId={id}
      />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent>
          <Section title={'General'}>
            <GeneralSection
              data={data}
              onOpenPromoCode={handleOpenPromoCode}
              id={id}
            />
          </Section>
          <Section title={'Budget and Payout'}>
            <BudgetAndPayoutSection data={data} />
          </Section>
          <Section
            isCollapsable={!!data?.agencies}
            initialOpen={true}
            title={`Agencies ${agencyCount}`}
          >
            <Agencies
              agencies={data?.agencies}
              attributionProviderId={data?.attributionProvider?.id}
            />
          </Section>
        </SidePage.NewContent>
        <SidePage.Sidebar
          actions={
            <ActionsWrapper
              data={data}
              onDuplicate={handleDuplicate}
              onEdit={handleEdit}
              onDelete={onClose}
            />
          }
        >
          <Metadata data={data} />
        </SidePage.Sidebar>
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default MasterCampaignDetails;
